import { render, staticRenderFns } from "./LegendDonutChart.vue?vue&type=template&id=ba35cfe4&scoped=true&"
import script from "./LegendDonutChart.vue?vue&type=script&lang=js&"
export * from "./LegendDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./LegendDonutChart.vue?vue&type=style&index=0&id=ba35cfe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba35cfe4",
  null
  
)

export default component.exports